import axios from 'axios';
import {
  ADD_MEALPLAN_FUNDS,
  ADD_TO_CART,
  GO_TO_CHECKOUT,
  RESET_PASSWORD,
  TOKEN_URL,
  UPDATE_PASSWORD,
  ITEM_EXIST,
  DETOR_MODIFIERS,
  USER_MEAL_PLAN_SETTINGS,
  ORDER_HISTROY_URL,
  LIST_USER_ADRRESS,
  SAVE_USER_ADRRESS,
  DELETE_USER_ADRRESS,
  REGISTER_URL,
  MEAL_PLAN_ENABLE_URL,
} from '../util/urls';
import * as URLS from '../util/urls';
import moment from 'moment';

const LANGUAGE_ID = localStorage.getItem('language') ? localStorage.getItem('language') : '1';

export const submitTopUpRequest = ({
  amount,
  nonce,
  user,
  dataname,
  tokenId,
  jwt,
}) => {
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + btoa(jwt),
    },
  };

  const body = {
    dataname,
    payment_method_nonce: nonce,
    payable_amount: amount,
    user_id: user,
    languageid : LANGUAGE_ID,
  };

  const handleErrors = response => {
    if (response.data.DataResponse.status === 'F') {
      throw new Error(response.data.DataResponse.msg);
    }

    return response;
  };

  return axios
    .post(`${ADD_MEALPLAN_FUNDS}tokenId/${tokenId}`, body, config)
    .then(handleErrors);
};

export const requestHeaders = jwt => {
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + btoa(jwt),
    },
  };
};

export const getItemTaxes = ({ cart_contents, dataname, tokenId, jwt }) => {
  const body = {
    dataname,
    cart_contents,
    languageid : LANGUAGE_ID,
  };
  return axios.post(
    `${ADD_TO_CART}tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const updateCartDetails = ({
  order_id,
  user_id,
  order_type,
  delivery_fee,
  cart_contents,
  dataname,
  locationid,
  tokenId,
  jwt,
}) => {
  let body = {
    dataname,
    cart_contents,
    order_id,
    user_id,
    order_type,
    delivery_fee,
    locationid,
    open_date: moment().format('YYYY-MM-DD HH:mm:ss'),
    languageid : LANGUAGE_ID,
  };

  return axios.post(
    `${GO_TO_CHECKOUT}tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const resetPassword = ({ email, dataname, tokenId, jwt }) => {
  const body = {
    email,
    dataname,
    languageid : LANGUAGE_ID,
  };
  return axios.post(
    `${RESET_PASSWORD}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const updatePassword = ({
  newPassword,
  confirmPassword,
  tokenId,
  jwt,
  resetToken,
}) => {
  const body = {
    token: resetToken,
    newpwd: newPassword,
    conpwd: confirmPassword,
    languageid : LANGUAGE_ID,
  };
  return axios.post(
    `${UPDATE_PASSWORD}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const getToken = () => {
  return axios.post(TOKEN_URL, {
    name: '!LaVu116!',
    prod: 'olo',
  });
};

export const itemExist = ({ itemId, dataname, diningType, tokenId, jwt }) => {
  const body = {
    dataname: dataname,
    item_id: itemId,
    dining_type: diningType,
    languageid : LANGUAGE_ID,
  };
  return axios.post(
    `${ITEM_EXIST}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const getDetor = ({ dataname, jwt, tokenId, detour_id }) => {
  return axios.get(
    `${DETOR_MODIFIERS}/tokenId/${tokenId}/dataname/${dataname}/detour_id/${detour_id}`,
    requestHeaders(jwt)
  );
};

export const getUserMealPlanSettings = ({ dataname, jwt, tokenId, user }) => {
  const body = {
    dataname: dataname,
    user_id: user,
  };
  return axios.post(
    `${USER_MEAL_PLAN_SETTINGS}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const getRestaurantLocations = ({
  lavuToGoName,
  dataname,
  tokenId,
  jwt,
}) => {
  const body = {
    dataname,
    lavu_togo_name: lavuToGoName,
  };

  return axios.post(
    `${URLS.RESTUARANT_LOCATION_BY_LAVU_TO_GO_NAME}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const getUserAddressess = ({ userId, tokenId, jwt }) =>
  axios.post(
    bindUrl(LIST_USER_ADRRESS, tokenId),
    { userId, languageid : LANGUAGE_ID }, 
    requestHeaders(jwt)
  );

export const saveUserAddress = ({
  user_id,
  name,
  address_1,
  address_2,
  country,
  state,
  city,
  zipcode,
  is_primary,
  id,
  tokenId,
  jwt,
}) =>
  axios.post(
    bindUrl(SAVE_USER_ADRRESS, tokenId),
    {
      user_id,
      name,
      address_1,
      address_2,
      country,
      state,
      city,
      zipcode,
      is_primary,
      id,
      languageid : LANGUAGE_ID,
    },
    requestHeaders(jwt)
  );
export const deleteUserAddress = ({ id, user_id, tokenId, jwt }) =>
  axios.post(
    bindUrl(DELETE_USER_ADRRESS, tokenId),
    {
      id,
      user_id,
      languageid : LANGUAGE_ID,
    },
    requestHeaders(jwt)
  );
export const registerUser = ({
  email,
  password,
  fname,
  lname,
  mobile,
  cpwd,
  name,
  address_1,
  address_2,
  country,
  state,
  city,
  zipcode,
  is_primary,
  jwt,
  tokenId,
}) =>
  axios.post(
    bindUrl(REGISTER_URL, tokenId),
    {
      email,
      password,
      fname,
      lname,
      mobile,
      cpwd,
      name,
      address_1,
      address_2,
      country,
      state,
      city,
      zipcode,
      is_primary: '1',
      languageid : LANGUAGE_ID,
    },
    requestHeaders(jwt)
  );

export const getMealPlanDetails = ({ dataname, jwt, tokenId, userId }) => {
  const body = {
    dataname: dataname,
    userId: userId,
  };
  return axios.post(
    `${MEAL_PLAN_ENABLE_URL}/tokenId/${tokenId}`,
    body,
    requestHeaders(jwt)
  );
};

export const bindUrl = (action, token) => `${action}/tokenId/${token}`;



// WEBPACK FOOTER //
// ./src/api/api.js